import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export default function PageHeader({ 
  title, 
  subtitle, 
  breadcrumbs = [],
  backgroundImage 
}) {
  return (
    <section 
      className="page-header page-header-pattern relative overflow-hidden"
      data-testid="page-header"
    >
      {backgroundImage && (
        <div 
          className="absolute inset-0 opacity-10"
          style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
      )}
      
      <div className="container-padding relative z-10">
        {/* Breadcrumbs */}
        {breadcrumbs.length > 0 && (
          <nav className="flex items-center space-x-2 text-sm text-slate-300 mb-6" data-testid="breadcrumbs">
            <Link to="/" className="hover:text-white transition-colors">
              Home
            </Link>
            {breadcrumbs.map((crumb, index) => (
              <React.Fragment key={crumb.label}>
                <ChevronRight className="w-4 h-4" />
                {crumb.href ? (
                  <Link to={crumb.href} className="hover:text-white transition-colors">
                    {crumb.label}
                  </Link>
                ) : (
                  <span className="text-white">{crumb.label}</span>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}

        <div className="max-w-3xl">
          <h1 
            className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight"
            style={{ fontFamily: 'Outfit, sans-serif' }}
            data-testid="page-title"
          >
            {title}
          </h1>
          {subtitle && (
            <p className="mt-6 text-lg md:text-xl text-slate-300 leading-relaxed" data-testid="page-subtitle">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
